import { useStore } from '@nanostores/react';
import { memo } from 'react';
import { Button } from '~/components/ui/Button';
import { Dialog, DialogActions, DialogButton, DialogContent, DialogHeader } from '~/components/ui/Dialog';
import { clientFetch } from '~/lib/.client/fetch';
import { chatStore } from '~/lib/stores/chat';
import { projectStore } from '~/lib/stores/project';
import { invariant } from '~/utils/invariant';

interface DiscordSupportModalProps {
  open: boolean;
  onClose: () => void;
}

export const DebugInfoModal = memo(({ open, onClose }: DiscordSupportModalProps) => {
  const message = useStore(chatStore.isDebugInfoModalOpen);

  const onShowMessageInfo = () => {
    console.debug(message);
  };

  const onShowDOInfo = () => {
    const projectId = projectStore.projectId.get();

    const metadata: any = message?.annotations?.find((annotation: any) => annotation.type === 'metadata');

    const messageId = metadata?.userMessageId;

    invariant(projectId);
    invariant(messageId);

    clientFetch('/api/chat/debug', {
      method: 'POST',
      body: JSON.stringify({
        projectId,
        message: messageId,
      }),
    }).then(async (response) => {
      if (!response.ok) {
        console.error('Failed to fetch debug info');
        return;
      }

      const data = await response.json();

      console.debug(data);
    });
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth={400}>
      <DialogHeader title="Debug Information" />
      <DialogContent>
        <div className="flex flex-col gap-4">
          <Button onClick={onShowMessageInfo}>Print message</Button>
          <Button onClick={onShowDOInfo}>Print Durable Object state</Button>
        </div>
      </DialogContent>
      <DialogActions>
        <DialogButton variant="secondary" onClick={onClose}>
          Close
        </DialogButton>
      </DialogActions>
    </Dialog>
  );
});
